
import { BasicButton } from "@goodgamestudios/asset-globals";

import { MathBase } from "@goodgamestudios/core";
import { BasicModel } from "@goodgamestudios/core";
import { BasicComboboxEvent } from "@goodgamestudios/core";

import { ColorTransform } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";

import { VOHelper } from "../../../basic/vo/VOHelper";

import { Poker2Constants } from "../../constants/Poker2Constants";
import { SFConstants } from "../../constants/SFConstants";
import { Poker2AvatarEvent } from "../../event/Poker2AvatarEvent";
import { Poker2DialogEvent } from "../../event/Poker2DialogEvent";
import { Poker2ShopEvent } from "../../event/Poker2ShopEvent";
import { Poker2UserEvent } from "../../event/Poker2UserEvent";
import { AvatarVO } from "../../gamevo/AvatarVO";
import { ColorTableVO } from "../../gamevo/ColorTableVO";
import { ItemsVO } from "../../gamevo/ItemsVO";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2MouseWheelUpDown } from "../components/Poker2MouseWheelUpDown";
import { ItemHelper } from "../helper/ItemHelper";
import { Poker2Screen } from "./Poker2Screen";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2ShopScreen extends Poker2Screen {
    public static NAME: string = "Poker2ShopScreen";

    private SORT_NUMERIC: number = 0;
    private SORT_DESCENDING: number = 1;

    private MAX_COLORS: number = 18;
    private ITEMS_PER_PAGE: number = 10;

    public static STATE_SHOP: string = "stateShop";
    public static STATE_INVENTORY: string = "stateInventory";

    public static STARTER_PACKAGE_AVAILABILITY: string = "NOT_IN_SHOP";

    private categoryButtons: any[];
    private subcategoryButtons: any[];
    private colorButtons: any[];
    private itemButtons: any[];

    private currentState: string;
    private currentCategory: string;
    private currentSubCategory: string;
    private currentPage: number = 0;
    private maxPage: number = 0;

    private currentColorId: number = -1;
    private selectedItem: ItemsVO;

    private levelSortComboBox: Poker2DynamicCombobox;
    private mouseWheelUpDown: Poker2MouseWheelUpDown;
    private _starterPackages: StarterPackagesComponent;

    constructor(disp: DisplayObject) {
        CONSTRUCTOR_HACK;
        super(disp);
    }
    protected init(): void {
        super.init();
        this.controller.addEventListener("changeShopState", this.bindFunction(this.onChangeState));
        this.controller.addEventListener("changeInventar", this.bindFunction(this.onChangeInventar));
        this.initComboBoxes();
        this.initTextFields();

        this.categoryButtons = [this.shopScreen.btn_look, this.shopScreen.btn_clothes, this.shopScreen.btn_extra, /*shopScreen.btn_booster,*/ this.shopScreen.btn_theme, this.shopScreen.btn_event, this.shopScreen.btn_starterPackages];

        // check if starter packages have to be displayed
        this.enableStarterPackageTab(true);

        this.subcategoryButtons = [this.shopScreen.btn_subcategory_shopGimmicks, this.shopScreen.btn_subcategory_shopAccessoires, this.shopScreen.btn_subcategory_shopPet, this.shopScreen.btn_subcategory_shopJewelry, this.shopScreen.btn_subcategory_shopBackground,
        this.shopScreen.btn_subcategory_shopTop, this.shopScreen.btn_subcategory_shopJacket, this.shopScreen.btn_subcategory_shopBottom, this.shopScreen.btn_subcategory_shopShoes,
        this.shopScreen.btn_subcategory_shopSkin, this.shopScreen.btn_subcategory_shopHair, this.shopScreen.btn_subcategory_shopEyes, this.shopScreen.btn_subcategory_shopNose, this.shopScreen.btn_subcategory_shopMouth, this.shopScreen.btn_subcategory_shopBeard];
        this.colorButtons = new Array();
        this.itemButtons = new Array();
        this.shopScreen.btn_subcategory_shopBeard.enableButton = Poker2Model.avatarData.myAvatar.gender == "male";
        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++)
            this.itemButtons.push(this.shopScreen.mc_shopitems["item" + i]);
        this.mouseWheelUpDown = new Poker2MouseWheelUpDown();
        this.mouseWheelUpDown.init(this.shopScreen.btn_leftarrow, this.shopScreen.btn_rightarrow, this.shopScreen);

        this.shopScreen.bg.doCache(0, 2);
        this.shopScreen.bg_feature.doCache();
        this.shopScreen.bg_shadow.doCache();

        // create starter package page
        this.createStartPackagesComponent();
    }

    private enableStarterPackageTab(flag: boolean): void {
        if (!flag || !Poker2Model.itemShop.starterPackages) {
            this.shopScreen.btn_starterPackages.enableButton = false;
            return;
        }

        this.shopScreen.btn_starterPackages.enableButton = true;
    }

    private createStartPackagesComponent(): void {
        this._starterPackages = new StarterPackagesComponent(this.shopScreen);
    }

    protected onUpdateStartPackages(event: Poker2ShopEvent): void {
        var boughtItemId: number = int(event.params[0]);
        this._starterPackages.disableItem(boughtItemId);
    }

    private killStarterPackages(): void {
        // sanity check
        if (!Poker2Model.itemShop.starterPackages) {
            return;
        }

        this._starterPackages.kill();
        this._starterPackages = null;
    }

    private initComboBoxes(): void {
        this.levelSortComboBox = new Poker2DynamicCombobox(this.shopScreen.combo_sort, "", 2);
        this.levelSortComboBox.addItem({ label: Poker2Model.languageData.getTextById("shop_combo_sort_" + this.SORT_DESCENDING) });
        this.levelSortComboBox.addItem({ label: Poker2Model.languageData.getTextById("shop_combo_sort_" + this.SORT_NUMERIC) });
        this.levelSortComboBox.defaultString = Poker2Model.languageData.getTextById("shop_combo_sort_" + this.SORT_DESCENDING);
    }
    private initTextFields(): void {
        this.shopScreen.txt_title.text = (this.currentState == "stateInventory") ? Poker2Model.languageData.getTextById("shop_btn_inventory") : Poker2Model.languageData.getTextById("menu_btn_shop");
        this.shopScreen.txt_title.doCache(0, 2.5);
        this.shopScreen.txt_sort.text = Poker2Model.languageData.getTextById("shop_txt_sort");
        this.shopScreen.btn_inventory.label = Poker2Model.languageData.getTextById("shop_btn_inventory");
        this.shopScreen.btn_shop.label = Poker2Model.languageData.getTextById("menu_btn_shop");
        this.shopScreen.btn_inventory.toolTipText = Poker2Model.languageData.getTextById("shop_btn_inventory");
        this.shopScreen.btn_shop.toolTipText = Poker2Model.languageData.getTextById("menu_btn_shop");
        this.shopScreen.btn_event.toolTipText = Poker2Model.languageData.getTextById("shop_btn_event");
        this.shopScreen.btn_theme.toolTipText = Poker2Model.languageData.getTextById("shop_btn_theme");
        this.shopScreen.btn_look.toolTipText = Poker2Model.languageData.getTextById("shop_btn_look");
        this.shopScreen.btn_clothes.toolTipText = Poker2Model.languageData.getTextById("shop_btn_clothes");
        this.shopScreen.btn_extra.toolTipText = Poker2Model.languageData.getTextById("shop_btn_extra");
        this.shopScreen.btn_starterPackages.toolTipText = Poker2Model.languageData.getTextById("shop_btn_bundle");
    }

    public show(): void {
        super.show();
        this.levelSortComboBox.disp.addEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onLevelSortComboboxChange));
        this.changeCategory("appearance");
        this.onChangeShopState("stateShop");
        this.mouseWheelUpDown.activateMouseWheel();
        this.controller.addEventListener("changeCategory", this.bindFunction(this.onChangeCategory));
        this.controller.addEventListener("changeSubCategory", this.bindFunction(this.onChangeSubCategory));
        this.controller.addEventListener("updateStartPackages", this.bindFunction(this.onUpdateStartPackages));
    }

    public hide(): void {
        super.hide();
        this.mouseWheelUpDown.deactivateMouseWheel();
        this.levelSortComboBox.disp.removeEventListener(BasicComboboxEvent.COMBOBOXCHANGE, this.bindFunction(this.onLevelSortComboboxChange));
        this.controller.dispatchEvent(new Poker2AvatarEvent("avatarReset"));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ShopScreen" + "_" + "stateShop", 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ShopScreen" + "_" + "stateInventory", 0]));
        this.selectedItem = null;
        this.controller.removeEventListener("changeCategory", this.bindFunction(this.onChangeCategory));
        this.controller.removeEventListener("changeSubCategory", this.bindFunction(this.onChangeSubCategory));
        this.controller.removeEventListener("updateStartPackages", this.bindFunction(this.onUpdateStartPackages));
    }

    private onChangeShopState(state: string): void {
        this.currentState = state;
        if (this.currentState == "stateShop") {
            this.shopScreen.btn_inventory.deselected();
            this.shopScreen.btn_shop.selected();

            // enable starter package tab
            this.enableStarterPackageTab(true);

            // starter package tab is not active in inventory, so jump to the appearance tab
            if (this.currentCategory == "starterPackages") {
                this._starterPackages.show();
            }
            else {
                this._starterPackages.hide();
            }
        }
        else if (this.currentState == "stateInventory") {
            this.resetColorButton();
            if (this.selectedItem)
                this.selectedItem = null;
            this.shopScreen.btn_inventory.selected();
            this.shopScreen.btn_shop.deselected();

            // starter package tab is not active in inventory, so jump to the appearance tab
            if (this.currentCategory == "starterPackages") {
                this.changeCategory("appearance");
            }

            // starter package tab not active in inventory state!
            this.enableStarterPackageTab(false);

            // hide starter packages
            this._starterPackages.hide();
        }
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ShopScreen" + "_" + "stateShop", (this.currentState == "stateShop") ? 1 : 0]));
        this.controller.dispatchEvent(new Poker2DialogEvent("menueselection", ["Poker2ShopScreen" + "_" + "stateInventory", (this.currentState == "stateInventory") ? 1 : 0]));

        this.shopScreen.txt_title.text = (this.currentState == "stateInventory") ? Poker2Model.languageData.getTextById("shop_btn_inventory") : Poker2Model.languageData.getTextById("menu_btn_shop");
        this.shopScreen.txt_title.doCache(0, 2.5);
        this.controller.dispatchEvent(new Poker2AvatarEvent("avatarReset"));
        this.fillItems();
    }

    private onChangeInventar(event: Poker2UserEvent): void {
        this.fillItems();
        this.sendAvatarToServer();
        this.controller.dispatchEvent(new Poker2AvatarEvent("avatarChanged"));
    }

    private onChangeState(event: Poker2UserEvent): void {
        switch (event.params[0]) {
            case "stateShop":
                this.onChangeShopState("stateShop");
                break;
            case "stateInventory":
                this.onChangeShopState("stateInventory");
                break;
        }
    }

    private onLevelSortComboboxChange(event: BasicComboboxEvent): void {
        this.fillItems();
    }

    public destroy(): void {
        super.destroy();
        this.controller.removeEventListener("changeShopState", this.bindFunction(this.onChangeState));
        this.controller.removeEventListener("changeInventar", this.bindFunction(this.onChangeInventar));
        this.mouseWheelUpDown.destroy();
        this.controller.removeEventListener("changeCategory", this.bindFunction(this.onChangeCategory));
        this.controller.removeEventListener("changeSubCategory", this.bindFunction(this.onChangeSubCategory));
        this.controller.removeEventListener("updateStartPackages", this.bindFunction(this.onUpdateStartPackages));
        this.killStarterPackages();
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.shopScreen.mc_shopitems.item0.btn_buy:
            case this.shopScreen.mc_shopitems.item1.btn_buy:
            case this.shopScreen.mc_shopitems.item2.btn_buy:
            case this.shopScreen.mc_shopitems.item3.btn_buy:
            case this.shopScreen.mc_shopitems.item4.btn_buy:
            case this.shopScreen.mc_shopitems.item5.btn_buy:
            case this.shopScreen.mc_shopitems.item6.btn_buy:
            case this.shopScreen.mc_shopitems.item7.btn_buy:
            case this.shopScreen.mc_shopitems.item8.btn_buy:
            case this.shopScreen.mc_shopitems.item9.btn_buy:
                this.buyItem(event.target.properties);
                break;
            case this.shopScreen.btn_inventory:
                this.onChangeShopState("stateInventory");
                break;
            case this.shopScreen.btn_shop:
                this.onChangeShopState("stateShop");
                break;
            case this.shopScreen.btn_look:
                this.changeCategory("appearance");
                break;
            case this.shopScreen.btn_clothes:
                this.changeCategory("cloths");
                break;
            case this.shopScreen.btn_extra:
                this.changeCategory("extras");
                break;
            case this.shopScreen.btn_event:
                this.changeCategory("event");
                break;
            case this.shopScreen.btn_starterPackages:

                if (!this.shopScreen.btn_starterPackages.enabled) {
                    return;
                }

                this.changeCategory("starterPackages");
                break;
            case this.shopScreen.btn_theme:
                this.changeCategory("theme");
                break;
            case this.shopScreen.btn_leftarrow:
            case this.shopScreen.btn_rightarrow:
                this.onClickArrow(event);
                break;
            default:
                if (event.target instanceof BasicButton && !event.target.enabled)
                    break;

                if (this.isButtonInArray(event.target as BasicButton, this.subcategoryButtons)) {
                    this.activateButton(event.target as BasicButton, this.subcategoryButtons);
                    this.changeSubCategory(event.target.properties);
                }
                if (this.isButtonInArray(event.target as BasicButton, this.colorButtons) && (this.currentColorId != event.target.colorId)) {
                    this.activateButton(event.target as BasicButton, this.colorButtons);
                    this.onChangeCurrentColor(event.target.colorId);
                    this.mergeAvatar();
                }
                if (event.target && instanceOfClass(event.target.parent, "PokerShopItem")) {
                    var item: BasicButton = event.target.parent as BasicButton;
                    if (this.selectedItem && this.selectedItem.id == item.itemId)
                        this.selectedItem = null;
                    else {
                        this.selectedItem = Poker2Model.wodData.getItemVObyID(item.itemId) as ItemsVO;
                        this.selectedItem.colorId = this.currentColorId;
                    }
                    if (this.currentState == "stateInventory") {
                        this.currentColorId = int(item.colorId);
                        this.helperShowInventoryColors(this.selectedItem);
                    }
                    this.activateButton(item, this.itemButtons, false);
                    this.mergeAvatar(item.itemId);
                }
                break;
        }
    }

    private mergeAvatar(newItemId: number = -1): void {
        if (this.currentState == "stateShop" && this.selectedItem == null) {
            this.controller.dispatchEvent(new Poker2AvatarEvent("avatarClothesChanged", [Poker2Model.avatarData.myAvatar]));
            return;
        }

        var avatar: AvatarVO;
        if (this.currentState == "stateInventory")
            avatar = Poker2Model.avatarData.myAvatar;
        else {
            avatar = VOHelper.clone(Poker2Model.avatarData.myAvatar) as AvatarVO;
            avatar.avatarWear = new Map<any, any>();
            for (let entryList of Array.from(Poker2Model.avatarData.myAvatar.avatarWear.values())) { var item: any = entryList; avatar.avatarWear.set(item.id, VOHelper.clone(item) as ItemsVO); }
        }

        var itemVO: ItemsVO = null;
        if (this.selectedItem) {
            itemVO = this.selectedItem;
            if (this.currentSubCategory == this.selectedItem.shopCategorySecondary)
                this.selectedItem.colorId = this.currentColorId;
            Poker2Model.avatarData.switchItem(this.selectedItem, avatar, newItemId < 0);
        }
        else if (this.currentState == "stateInventory" && newItemId >= 0) {
            itemVO = avatar.avatarWear.get(newItemId);
            if (!itemVO.inventoryAmount || isNaN(itemVO.inventoryAmount))
                itemVO.inventoryAmount = 1;
            Poker2Model.avatarData.switchItem(itemVO, avatar);
        }
        this.controller.dispatchEvent(new Poker2AvatarEvent("avatarClothesChanged", [avatar]));

        if (this.currentState == "stateInventory" && itemVO)
            this.sendAvatarToServer();
    }

    private sendAvatarToServer(): void {
        var itemsArray: any[] = new Array();
        for (let entryList of Array.from(Poker2Model.avatarData.myAvatar.avatarWear.values())) {
            var itemsVO: any = entryList;
            if (itemsVO === undefined) { continue; }

            // Hier wird verhindert, das dem Server die Unterwäsche geschickt wird, da diese immer zum Avatar gehört
            if (itemsVO.itemCategory != "underwearBottom" && itemsVO.itemCategory != "underwearTop")
                itemsArray.push([itemsVO.id, itemsVO.colorId]);
        }

        BasicModel.smartfoxClient.sendMessage("ivw", [JSON.stringify({ L: itemsArray })]);
    }

    private isButtonInArray(button: BasicButton, array: any[]): boolean {
        if (button == null || array == null)
            return false;

        for (var i: number = 0; i < array.length; i++) {
            if (button == array[i])
                return true;
        }
        return false;
    }

    private onChangeCurrentColor(colorId: number): void {
        this.currentColorId = colorId;
        this.fillItems();
    }
    /**
     * Pfeil-Button initialisieren, je nach Anzahl an Items werden die Button angezeigt
     */
    private initArrows(nofItems: number): void {
        this.maxPage = int((nofItems - 1) / this.ITEMS_PER_PAGE);
        this.shopScreen.btn_rightarrow.visible = this.shopScreen.btn_leftarrow.visible = (this.maxPage > 0);
        this.shopScreen.btn_rightarrow.enableButton = (this.maxPage > 0 && this.currentPage < this.maxPage);
        this.shopScreen.btn_leftarrow.enableButton = (this.maxPage > 0 && this.currentPage > 0);
    }

    private onClickArrow(event: MouseEvent): void {
        var oldPage: number = this.currentPage;
        if (event.target == this.shopScreen.btn_leftarrow)
            this.currentPage = int(Math.max(0, this.currentPage - 1));
        else
            this.currentPage = int(Math.min(this.maxPage, this.currentPage + 1));
        if (oldPage != this.currentPage)
            this.fillItems();
    }

    private buyItem(itemID: number): void {
        var item: any[] = [[itemID, this.currentColorId]];
        BasicModel.smartfoxClient.sendMessage("sbu", [JSON.stringify({ L: item })]);
    }

    protected onChangeCategory(event: Poker2ShopEvent): void {
        var category: string = event.params[0].toString();
        this.changeCategory(category);
    }

    protected onChangeSubCategory(event: Poker2ShopEvent): void {
        var subCategory: string = event.params[0].toString();

        this._starterPackages.hide();
        this.activateButton(this.shopScreen["btn_subcategory_" + subCategory], this.subcategoryButtons);
        this.changeSubCategory(subCategory);
    }

    private changeCategory(category: string): void {
        this._starterPackages.hide();

        this.currentCategory = category;
        switch (this.currentCategory) {
            case "appearance":
                this.activateButton(this.shopScreen.btn_look, this.categoryButtons);
                this.helperShowSubCategories(Poker2Constants.SUB_CATEGORIES_APPEARANCE);
                this.changeSubCategory("shopSkin");
                break;
            case "cloths":
                this.activateButton(this.shopScreen.btn_clothes, this.categoryButtons);
                this.helperShowSubCategories(Poker2Constants.SUB_CATEGORIES_CLOTHS);
                this.changeSubCategory("shopTop");
                break;
            case "extras":
                this.activateButton(this.shopScreen.btn_extra, this.categoryButtons);
                this.helperShowSubCategories(Poker2Constants.SUB_CATEGORIES_EXTRAS);
                this.changeSubCategory("shopBackground");
                break;
            case "event":
                this.activateButton(this.shopScreen.btn_event, this.categoryButtons);
                this.helperShowSubCategories(Poker2Constants.SUB_CATEGORIES_EVENT);
                this.changeSubCategory("shopCostume");
                break;
            case "theme":
                this.activateButton(this.shopScreen.btn_theme, this.categoryButtons);
                this.helperShowSubCategories(Poker2Constants.SUB_CATEGORIES_THEME);
                this.changeSubCategory("shopScreen");
                break;
            case "starterPackages":

                this.activateButton(this.shopScreen.btn_starterPackages, this.categoryButtons);
                this.helperShowSubCategories(Poker2Constants.SUB_CATEGORIES_THEME);
                this.showStarterPackages();
                break;
        }
    }

    private showStarterPackages(): void {
        // sanity check
        if (!Poker2Model.itemShop.starterPackages) {
            return;
        }

        this.clearItemHolder();

        // show starte packages
        this._starterPackages.show();
    }

    private clearItemHolder(): void {
        this.shopScreen.mc_shopitems.visible = false;
    }

    private changeSubCategory(subCategory: string): void {
        this.currentPage = 0;
        this.currentSubCategory = subCategory;
        this.currentColorId = -1;
        this.resetColorButton();
        this.fillItems();
    }

    private activateButton(selectedButton: BasicButton, buttonGroup: any[], explicitly: boolean = true): void {
        var selected: boolean = selectedButton.isSelected;
        for (var i: number = 0; i < buttonGroup.length; i++)
            buttonGroup[i].deselected();
        if (!selected || explicitly)
            selectedButton.selected();
        else
            selectedButton.deselected();
    }

    private fillItems(): void {
        var currentShopItem: number = this.currentPage * this.ITEMS_PER_PAGE;
        var filteredArray: any[] = this.getFilteredArray();
        this.initArrows(filteredArray.length);

        if (filteredArray.length > 0 && this.currentState == "stateShop") {
            this.helperShowColors(filteredArray[0].colorTableId);
        }

        // show items container
        this.shopScreen.mc_shopitems.visible = true;

        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            var cItem: Library.PokerInterface.PokerShopItem = this.shopScreen.mc_shopitems["item" + i] as Library.PokerInterface.PokerShopItem;
            cItem.btn_buy.toolTipText = Poker2Model.languageData.getTextById("shop_tooltip_buy_btn");
            if (currentShopItem < filteredArray.length) {
                cItem.mouseEnabled = cItem.mouseChildren = true;
                cItem.mc_content.mouseEnabled = cItem.mc_content.mouseChildren = false;

                if (this.currentState == "stateShop") {
                    this.createShopItem(filteredArray[currentShopItem], cItem);
                }
                else {
                    this.createInventoryItem(filteredArray[currentShopItem], cItem);
                }
            }
            cItem.visible = (currentShopItem < filteredArray.length);
            currentShopItem++;
        }
    }

    private createInventoryItem(itemVO: ItemsVO, itemHolder: Library.PokerInterface.PokerShopItem): void {
        var colorIds: any[] = Poker2Model.inventoryData.getInventoryColorIDsByWodId(itemVO.id);
        if (colorIds.indexOf(this.currentColorId) >= 0)
            itemHolder.colorId = this.currentColorId;
        else {
            if (colorIds.length > 0) {
                var randomIndex: number = int(MathBase.random(0, colorIds.length - 1));
                itemHolder.colorId = colorIds[randomIndex];
            }
            else
                itemHolder.colorId = -1;
        }
        itemHolder.mc_blocked.visible = false;
        itemVO.currentColor = Poker2Model.itemShop.getColorById(itemHolder.colorId);

        itemHolder.txt_cash.text = "";
        itemHolder.txt_gold.text = "";
        itemHolder.mc_chips.visible = false;
        itemHolder.mc_gold.visible = false;
        itemHolder.btn_buy.visible = false;
        itemHolder.mc_content.mc_line.visible = false;
        itemHolder.itemId = itemVO.id;
        itemHolder.toolTipText = null;
        itemHolder.properties = itemVO.id;
        itemHolder.deselected();
        var itemMC: Container;
        if (itemVO.shopCategorySecondary == "shopScreen") {
            itemMC = AvatarHelper.drawItem(itemVO, true);
        } else if (itemVO.shopCategorySecondary == "shopJewelry" ||
            itemVO.shopCategorySecondary == "shopNose" ||
            itemVO.shopCategorySecondary == "shopMouth" ||
            itemVO.shopCategorySecondary == "shopEyes" ||
            itemVO.shopCategorySecondary == "shopBeard" ||
            itemVO.shopCategorySecondary == "shopShoes" ||
            itemVO.shopCategorySecondary == "shopGimmicks" ||
            itemVO.shopCategorySecondary == "shopPet" ||
            itemVO.shopCategorySecondary == "shopAccessoires") {
            itemMC = AvatarHelper.drawItem(itemVO, false, "_big");
        }
        else {
            itemMC = AvatarHelper.drawItem(itemVO);
        }

        ItemHelper.scaleItem(itemMC, 80);
        itemMC.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        let ctx = itemMC.cacheCanvas.getContext('2d');
        ctx.filter = 'drop-shadow(0px 0px 2px #D3D3D3)'; // TODO - this is still experimental and can change in the future, refer to the MDN documentation
        ctx.drawImage(itemMC.cacheCanvas, 0, 0);
        
        while (itemHolder.mc_content.mc_itemholder.numChildren > 0) {
            itemHolder.mc_content.mc_itemholder.removeChildAt(0);
        }
        itemHolder.mc_content.mc_itemholder.addChild(itemMC);
        itemHolder.mc_content.mouseEnabled = true;

        // center itemMC vertically
        itemMC.y += Math.abs(itemHolder.mc_content.mc_itemholder.y);
    }

    private createShopItem(itemVO: ItemsVO, itemHolder: Library.PokerInterface.PokerShopItem): void {
        if (itemVO.colorTableId != -1 && this.currentColorId >= 0)
            itemVO.currentColor = Poker2Model.itemShop.getColorById(this.currentColorId);

        itemHolder.btn_buy.visible = true;
        itemHolder.mc_blocked.visible = false;
        itemHolder.txt_cash.text = itemVO.priceChips + "";
        itemHolder.mc_chips.visible = itemHolder.txt_cash.visible = itemVO.priceChips > 0;
        itemHolder.txt_gold.text = itemVO.priceGold + "";
        itemHolder.mc_gold.visible = itemHolder.txt_gold.visible = itemVO.priceGold > 0;
        itemHolder.btn_buy.properties = itemVO.id;
        itemHolder.itemId = itemVO.id;
        itemHolder.properties = itemVO.id;
        itemHolder.mc_content.mc_line.visible = true;

        // hat das Item bereit in der Farbe
        if (Poker2Model.inventoryData.hasItemByWodIdAndColor(itemVO.id, this.currentColorId)) {
            itemHolder.mc_blocked.txt_copy.text = "";
            itemHolder.mc_blocked.gotoAndStop(2);
            itemHolder.mc_blocked.changeTextFieldCacheScale(2);
            itemHolder.mc_blocked.visible = true;
        }
        // hat noch nicht das entsprechende Level (kann nicht mit obiger Abfrage kollidieren)
        var minUnlockLevel: string;
        if (itemVO.level > Poker2Model.userData.userLevel) {
            minUnlockLevel = Poker2Model.languageData.getTextById("shop_minlevel", [itemVO.level]);
            itemHolder.mc_blocked.txt_copy.text = minUnlockLevel;
            itemHolder.mc_blocked.gotoAndStop(1);
            itemHolder.mc_blocked.changeTextFieldCacheScale(2);
            itemHolder.mc_blocked.visible = true;
        }

        // temporary item: will be unlocked not before a special date!
        if (!isNaN(itemVO.unlockDate) && itemVO.unlockDate >= Poker2Model.timestampServer) {
            var unlockDate: Date = new Date(itemVO.unlockDate);
            var month: string = (unlockDate.getMonth() + 1).toString();
            var unlockMessageStr: string = unlockDate.getDate() + "." + month + "." + unlockDate.getFullYear();

            if (minUnlockLevel) {
                unlockMessageStr = minUnlockLevel + " \n " + unlockMessageStr;
            }

            itemHolder.mc_blocked.txt_copy.text = unlockMessageStr;
            itemHolder.mc_blocked.gotoAndStop(3);
            itemHolder.mc_blocked.changeTextFieldCacheScale(2);
            itemHolder.mc_blocked.visible = true;
        }

        itemHolder.mouseEnabled = itemHolder.mouseChildren = !itemHolder.mc_blocked.visible;

        var itemMC: Container;
        if (itemVO.shopCategorySecondary == "shopScreen") {
            itemMC = AvatarHelper.drawItem(itemVO, true);
        }
        else if (itemVO.shopCategorySecondary == "shopJewelry" ||
                 itemVO.shopCategorySecondary == "shopNose" ||
                 itemVO.shopCategorySecondary == "shopMouth" ||
                 itemVO.shopCategorySecondary == "shopEyes" ||
                 itemVO.shopCategorySecondary == "shopBeard" ||
                 itemVO.shopCategorySecondary == "shopShoes" ||
                 itemVO.shopCategorySecondary == "shopGimmicks" ||
                 itemVO.shopCategorySecondary == "shopPet" ||
                 itemVO.shopCategorySecondary == "shopAccessoires") {
            itemMC = AvatarHelper.drawItem(itemVO, false, "_big");
        }
        else {
            itemMC = AvatarHelper.drawItem(itemVO);
        }

        ItemHelper.scaleItem(itemMC);
        itemMC.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        let ctx = itemMC.cacheCanvas.getContext('2d');
        ctx.filter = 'drop-shadow(0px 0px 2px #D3D3D3)'; // TODO - this is still experimental and can change in the future, refer to the MDN documentation
        ctx.drawImage(itemMC.cacheCanvas, 0, 0);

        if (this.selectedItem && this.selectedItem.id == itemVO.id)
            itemHolder.selected();
        else
            itemHolder.deselected();

        while (itemHolder.mc_content.mc_itemholder.numChildren > 0) {
            itemHolder.mc_content.mc_itemholder.removeChildAt(0);
        }
        itemHolder.mc_content.mc_itemholder.addChild(itemMC);
        itemHolder.mc_content.mouseEnabled = true;
    }

    private getFilteredArray(): any[] {
        var result: any[] = [];
        var search: any[];
        if (this.currentState == "stateShop") {
            search = Poker2Model.itemShop[this.currentSubCategory];
            result = this.getFilteredResultForShop(search);
        }
        else {
            search = Poker2Model.inventoryData.getInventoryBySubCategory(this.currentSubCategory);
            result = this.getFilteredResultForInventory(search);
        }

        result.sortOn(["level", "priceGold", "priceChips", "id"], [Array.NUMERIC]);

        if (this.levelSortComboBox && this.levelSortComboBox.selectedId == this.SORT_DESCENDING)
            result.reverse();
        return result;
    }

    private getFilteredResultForShop(search: any[]): any[] {
        var result: any[] = [];
        if (search != null) {
            for (let entryList of search) {
                var itemVO: any = entryList;
                if (itemVO === undefined) continue;

                if ((itemVO.sex == Poker2Model.avatarData.myAvatar.gender || itemVO.sex == "both")
                    && itemVO.isItemAvalibleByEvent()
                    && itemVO.availability != "NOT_IN_SHOP"
                ) {
                    result.push(VOHelper.clone(itemVO) as ItemsVO);
                }
            }
        }

        return result;
    }

    private getFilteredResultForInventory(search: any[]): any[] {
        var result: any[] = [];
        if (search != null) {
            for (let entryList of search) {
                var itemVO: any = entryList;
                if (itemVO === undefined) continue;

                if ((itemVO.sex == Poker2Model.avatarData.myAvatar.gender || itemVO.sex == "both")
                ) {
                    result.push(VOHelper.clone(itemVO) as ItemsVO);
                }
            }
        }

        return result;
    }

    private itemIsNoStarterPackageItem(itemId: number): boolean {
        // starer packages undefined -> item is no starter package item
        if (!Poker2Model.itemShop.starterPackages) {
            return true;
        }

        for (let entryList of Poker2Model.itemShop.starterPackagesItemIds) {
            var spItemVO: any = entryList;
            if (spItemVO === undefined) continue;

            if (spItemVO.id == itemId) {
                return false;
            }
        }

        return true;
    }

    private helperShowSubCategories(subcategoryArray: any[]): void {
        for (var d: number = 0; d < this.subcategoryButtons.length; d++) {
            this.subcategoryButtons[d].deselected();
            this.subcategoryButtons[d].visible = false;
        }

        this.subcategoryButtons = new Array();
        for (var i: number = 0; i < subcategoryArray.length; i++) {
            var subCategoryButton: BasicButton = castAs<BasicButton>(this.shopScreen["btn_subcategory_" + String(subcategoryArray[i])], "BasicButton");
            if (subCategoryButton == null)
                continue;
            subCategoryButton.visible = true;
            subCategoryButton.properties = subcategoryArray[i];
            subCategoryButton.toolTipText = Poker2Model.languageData.getTextById("shop_btn_subcategory_" + String(subcategoryArray[i]));
            this.subcategoryButtons.push(subCategoryButton);
        }
        if (this.subcategoryButtons.length > 0)
            this.activateButton(this.subcategoryButtons[0], this.subcategoryButtons);
    }

    private resetColorButton(): void {
        this.colorButtons = new Array();
        while (this.shopScreen.mc_colorbuttonholder.numChildren > 0)
            this.shopScreen.mc_colorbuttonholder.removeChildAt(0);
    }

    private helperShowColors(colorTableId: number): void {
        var colorIds: any[] = new Array();
        var colorTables: any[] = Poker2Model.itemShop.getColorTableByTableId(colorTableId);
        for (var i: number = 0; i < colorTables.length; i++)
            colorIds.push((colorTables[i] as ColorTableVO).id);
        this.showColors(colorIds);
    }

    private helperShowInventoryColors(itemVO: ItemsVO): void {
        if (itemVO)
            this.showColors(Poker2Model.inventoryData.getInventoryColorIDsByWodId(itemVO.id));
    }

    private showColors(colorIdArray: any[]): void {
        this.resetColorButton();
        var ct: ColorTransform = new ColorTransform();
        var currentColorIndex: number = 0;
        for (var i: number = 0; i < colorIdArray.length; i++) {
            if (colorIdArray[i] < 0)
                continue;
            var colorButton: Library.PokerInterface.Btn_ShopColor = new Library.PokerInterface.Btn_ShopColor();
            ct.color = (int)(Poker2Model.itemShop.getColorById(colorIdArray[i]));
            colorButton.colorId = colorIdArray[i];
            colorButton.cc.transform.colorTransform = ct;
            this.shopScreen.mc_colorbuttonholder.addChild(colorButton);
            this.colorButtons.push(colorButton);

            if (this.currentColorId < 0 && i == 0)
                this.currentColorId = int(colorIdArray[i]);

            if (this.currentColorId == colorIdArray[i])
                currentColorIndex = i;
        }
        this.positionColorBtn();

        if (this.colorButtons.length > 0)
            this.activateButton(this.colorButtons[currentColorIndex], this.colorButtons);
        else
            this.currentColorId = -1;
    }

    private positionColorBtn(): void {
        for (var i: number = 0; i < this.shopScreen.mc_colorbuttonholder.numChildren; i++) {
            var child: MovieClip = castAs<MovieClip>(this.shopScreen.mc_colorbuttonholder.getChildAt(i), "MovieClip");
            if (!child) continue;
            child.x = (child.width + 5) * (i % this.MAX_COLORS);
            child.y = (child.height + 5) * int(i / this.MAX_COLORS);
        }
    }

    public get shopScreen(): Library.PokerInterface.PokerShop {
        return this.disp as Library.PokerInterface.PokerShop;
    }
}

import { AvatarHelper } from "../helper/AvatarHelper";
import { StarterPackagesComponent } from "./shop/StarterPackagesComponent";

import { castAs } from "@goodgamestudios/createjs-utilities";

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import {Poker2DynamicCombobox} from "../components/Poker2DynamicCombobox";
import {Poker2LayoutManager} from "../Poker2LayoutManager";
